var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order"},[(_vm.orderType == 'single')?_c('SingleOrder',{attrs:{"prod":_vm.prod}}):_c('MultipleOrders',{attrs:{"prod":_vm.prod}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eabfbb2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderCard.vue
// module id = null
// module chunks = 